export default "__VITE_ASSET__D$RnPQqW__"